<template>
  <div class="menu-title">
    <span>{{ title ? title : getMenuTitle }}</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["activeMenu", "childMenuList"]),
    getMenuTitle() {
      const activePathArr = this.activeMenu.split("/");
      const activePath = activePathArr[activePathArr.length - 1];
      let name;
      this.childMenuList[0] &&
        this.childMenuList[0].forEach((list) => {
          if (!name) {
            if (list.path == `/${activePath}`) {
              name = list.name;
            }
            if (!name && list.children && list.children.length) {
              list.children.forEach((child) => {
                if (child.path == `/${activePath}`) {
                  name = child.name;
                }
              });
            }
          }
        });
      return name;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-title {
  font-size: $font-size16;
  font-weight: 600;
  line-height: $font-size16;
  margin-bottom: 24px;
}
</style>